import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    CardTitle,
} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    LIST,
    NO,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
    ButtonTableDelete,
    ButtonTableEdit,
} from "../../../components/buttons/buttonsActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {remove, search} from "../../../redux/actions/eventx/legalActions";
import {connect} from "react-redux";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import LegalFilter from "./_filter";
import LegalForm from "./_form";
import ServicesForm from "../../clasificators/services/_form";

function LegalList(props) {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const { udn } = props.mainProps;
    const [staticFilter, setStaticFilter] = useState({
        fbDataBase : {  id : null },
        item : {
            //udn: udn?.id
        }
    })

    useEffect(()=>{
        setStaticFilter({
            ...staticFilter,
            fbDataBase: { id : props.mainProps?.app?.fbDataBase?.id },
            item :{
                //udn: udn?.id
            },
            onlyRegistered: true
        })

    },[props.mainProps?.app?.fbDataBase?.id, udn?.id])


    useEffect(() => {
        if(!staticFilter.fbDataBase.id)
            return;
        if ( filter === undefined || filter === null){
            refreshDataList(pageIndex, pageSize, staticFilter);
            return;
        }
        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter, staticFilter]);


    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        props.remove(data.id, props.mainProps?.app?.fbDataBase?.id)
    }

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        ModalFormContainer(LegalForm, { data: data, Form: LegalForm });
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <ButtonTableDelete onClick={() => confirmDelete(row)}/>
                <ButtonTableEdit onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'uid',
        text: 'UID',
        headerStyle: {width: '150px'},
        sort: true
    },{
        dataField: 'title',
        headerStyle: {width: '250px'},
        text: 'Titulo'
    }, {
        dataField: 'code',
        headerStyle: {width: '150px'},
        text: 'Código'
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '30px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <LegalFilter />
                <CardBody className="">
                        <BootstrapTable
                            striped hover
                            tableHeaderClass='mb-0'
                            remote
                            keyField="id"
                            data={listDomainObjects || []}
                            columns={columns}
                            pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                            onTableChange={handleTableChange}
                        />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
})
export default connect(mapStateToProps, mapActionsToProps)(LegalList)